import matrix from './rbacMatrix.json';

export const WORKSPACE_ROLES = Object.freeze({
  OWNER: 'owner',
  ADMIN: 'admin',
  MEMBER: 'member',
});

export const RBAC_VERSION = matrix.version;
export const RBAC_ROLES = Object.freeze([...matrix.roles]);
export const RBAC_ACTIONS = Object.freeze({ ...matrix.actions });

export function normalizeRole(role) {
  const value = String(role || '').trim().toLowerCase();
  return RBAC_ROLES.includes(value) ? value : null;
}

export function canRole(role, action) {
  const normalizedRole = normalizeRole(role);
  if (!normalizedRole) return false;

  const permissions = RBAC_ACTIONS[action];
  if (!permissions) return false;

  return permissions[normalizedRole] === true;
}

export function getCurrentUserWorkspaceRole({ workspace, userKey, memberByUserKey }) {
  if (!workspace || !userKey) return null;

  if (workspace.ownerKey === userKey) {
    return WORKSPACE_ROLES.OWNER;
  }

  const memberRow = memberByUserKey?.[userKey] || null;
  const role = normalizeRole(memberRow?.role);
  return role || null;
}

export function canUserInWorkspace({ workspace, userKey, memberByUserKey, action }) {
  const role = getCurrentUserWorkspaceRole({ workspace, userKey, memberByUserKey });
  return canRole(role, action);
}
